import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { SignupForms } from './pages/SignupForms';
import { SignupFormEditor } from './pages/SignupFormEditor';
import { EmbedCodes } from './pages/EmbedCodes';
import { EmailTemplates } from './pages/EmailTemplates';
import { EmailTemplateEditor } from './pages/EmailTemplateEditor';
import { FormConfiguration } from './pages/FormConfiguration';
import { ConfigurationsList } from './pages/ConfigurationsList';
import { Submissions } from './pages/Submissions';
import { Subscriptions } from './pages/Subscriptions';
import { Contacts } from './pages/Contacts';
import { Users } from './pages/Users';
import { Settings } from './pages/Settings';
import { SuperAdminSettings } from './pages/SuperAdminSettings';
import { Newsletters } from './pages/Newsletters';
import { NewsletterEditor } from './pages/NewsletterEditor';
import { Campaigns } from './pages/Campaigns';
import { CampaignBuilder } from './pages/CampaignBuilder';
import { AuditLog } from './pages/AuditLog';
import { Tags } from './pages/Tags';
import { TagDetail } from './pages/TagDetail';
import { MailingLists } from './pages/MailingLists';
import { MailingListDetail } from './pages/MailingListDetail';
import { RolesPermissions } from './pages/RolesPermissions';
import { WorkspaceProvider } from './contexts/WorkspaceContext';
import { SendBucketManager } from './pages/SendBucketManager';
export function App() {
  return <WorkspaceProvider data-id="element-0">
      <Router data-id="element-1">
        <Layout data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Navigate to="/mailing-lists" replace data-id="element-5" />} data-id="element-4" />

            <Route path="/mailing-lists" element={<MailingLists data-id="element-7" />} data-id="element-6" />
            <Route path="/mailing-lists/:listId" element={<MailingListDetail data-id="element-9" />} data-id="element-8" />

            <Route path="/newsletters" element={<Newsletters data-id="element-11" />} data-id="element-10" />
            <Route path="/newsletters/new" element={<NewsletterEditor data-id="element-13" />} data-id="element-12" />

            <Route path="/contacts" element={<Contacts data-id="element-15" />} data-id="element-14" />

            <Route path="/forms" element={<SignupForms data-id="element-17" />} data-id="element-16" />
            <Route path="/forms/new" element={<SignupFormEditor data-id="element-19" />} data-id="element-18" />
            <Route path="/forms/:id" element={<SignupFormEditor data-id="element-21" />} data-id="element-20" />
            <Route path="/forms/:id/embed" element={<EmbedCodes data-id="element-23" />} data-id="element-22" />

            <Route path="/templates" element={<EmailTemplates data-id="element-25" />} data-id="element-24" />
            <Route path="/templates/new" element={<EmailTemplateEditor data-id="element-27" />} data-id="element-26" />
            <Route path="/templates/:id" element={<EmailTemplateEditor data-id="element-29" />} data-id="element-28" />

            <Route path="/configurations" element={<ConfigurationsList data-id="element-31" />} data-id="element-30" />
            <Route path="/configuration/new" element={<FormConfiguration data-id="element-33" />} data-id="element-32" />

            <Route path="/tags" element={<Tags data-id="element-35" />} data-id="element-34" />
            <Route path="/tags/:tagName" element={<TagDetail data-id="element-37" />} data-id="element-36" />

            <Route path="/campaigns" element={<Campaigns data-id="element-39" />} data-id="element-38" />
            <Route path="/campaigns/new" element={<CampaignBuilder data-id="element-41" />} data-id="element-40" />
            <Route path="/campaigns/:id/edit" element={<CampaignBuilder data-id="element-43" />} data-id="element-42" />

            <Route path="/submissions" element={<Submissions data-id="element-45" />} data-id="element-44" />
            <Route path="/subscriptions" element={<Subscriptions data-id="element-47" />} data-id="element-46" />
            <Route path="/audit-log" element={<AuditLog data-id="element-49" />} data-id="element-48" />
            <Route path="/users" element={<Users data-id="element-51" />} data-id="element-50" />
            <Route path="/roles" element={<RolesPermissions data-id="element-53" />} data-id="element-52" />
            <Route path="/settings" element={<Settings data-id="element-55" />} data-id="element-54" />

            <Route path="/send-buckets" element={<SendBucketManager data-id="element-57" />} data-id="element-56" />

            <Route path="/super-admin" element={<SuperAdminSettings data-id="element-59" />} data-id="element-58" />
          </Routes>
        </Layout>
      </Router>
    </WorkspaceProvider>;
}